import { getCurrentDate } from './getCurrentDate';
export function getDifferenceInSeconds(dateFrom) {
    var dateTo = getCurrentDate();
    return (dateTo.getTime() - dateFrom.getTime()) / 1000;
}
//# sourceMappingURL=getDifferenceInSeconds.js.map